var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareer03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 27,
    viewBox: "0 0 34 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0422 19.0273L28.4463 14.4366C27.8356 13.8258 27.006 13.4848 26.1408 13.4848H22.1048C21.2039 13.4848 20.4761 14.2126 20.4761 15.1135V19.1444C20.4761 20.0096 20.8171 20.8341 21.4279 21.4449L26.0237 26.0356C26.6599 26.6718 27.6931 26.6718 28.3293 26.0356L33.0371 21.3278C33.6784 20.6916 33.6784 19.6635 33.0422 19.0273ZM23.7385 17.9585C23.0616 17.9585 22.517 17.4139 22.517 16.737C22.517 16.0601 23.0616 15.5155 23.7385 15.5155C24.4154 15.5155 24.96 16.0601 24.96 16.737C24.96 17.4089 24.4154 17.9585 23.7385 17.9585ZM12.3481 13.4797C15.9464 13.4797 18.8627 10.5634 18.8627 6.9651C18.8627 3.37188 15.9464 0.455566 12.3481 0.455566C8.74979 0.455566 5.83347 3.37188 5.83347 6.97019C5.83347 10.5634 8.74979 13.4797 12.3481 13.4797ZM18.8525 19.1393V15.4188C18.2316 15.2356 17.5852 15.1033 16.9083 15.1033H16.0584C14.9285 15.6224 13.6714 15.9176 12.3481 15.9176C11.0248 15.9176 9.77279 15.6224 8.63782 15.1033H7.78786C4.01142 15.1084 0.947507 18.1723 0.947507 21.9487V24.066C0.947507 25.4147 2.04176 26.509 3.39049 26.509H21.3057C22.0946 26.509 22.7868 26.1272 23.2346 25.547L20.2827 22.5951C19.3615 21.6739 18.8525 20.4473 18.8525 19.1393Z",
    fill: "#1CBEEF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1437,
    cy: 6.97992,
    r: 6.50433,
    fill: "#1CBEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareer03);
export default __webpack_public_path__ + "static/media/career-03.25a7818b4edd0273fbf3e8e1475141e6.svg";
export { ForwardRef as ReactComponent };